import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { NumberField } from '@prismicio/client';

import styles from './range.module.scss';

interface RangeProps {
  min: NumberField;
  max: NumberField;
  step: NumberField;
  value: number;
  onChange: Dispatch<SetStateAction<number>>;
  isVisible: boolean | null;
  id?: string;
}
export const Range = ({
  min,
  max,
  step,
  value,
  onChange,
  isVisible,
  id = 'calculate-loan-amount',
}: RangeProps) => {
  const backgroundRange = ((value / max!) as number) * 100;

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    onChange(Number(target.value));
  };

  return (
    <label htmlFor={id} aria-label="Calculate loan amout">
      <input
        id={id}
        className={`${styles.range} ${isVisible !== null && styles.mediumAnimation} ${isVisible ? styles.isVisible : ''}`}
        style={{
          background: `linear-gradient(to right, #18C2DE ${backgroundRange}%, #ffffff33 ${backgroundRange}%)`,
        }}
        type="range"
        min={min as number}
        max={max as number}
        step={step as number}
        value={value}
        onChange={handleChange}
      />
    </label>
  );
};
